import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Converte string "YYYY-MM-DD" em Date no horário local,
 * evitando shift de timezone causado by new Date("YYYY-MM-DD") que interpreta como UTC.
 */
export function parseDateLocal(dateStr: string): Date {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/**
 * Converte cor hex para rgba com opacidade.
 * Útil para gerar fundos tonificados (tints) baseados na cor da fase.
 */
export function hexToRgba(hex: string | null | undefined, alpha: number): string {
  if (!hex || !hex.startsWith('#')) return `rgba(107, 114, 128, ${alpha})`; // Default gray (muted-foreground)
  
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
